
import { Vue, Component } from "vue-property-decorator";

@Component({ name: "icon-eye" })
export default class IconEye extends Vue {
  sData: string = require("@icon/feather/eye.svg");
}
